import { Chart, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningPerformanceOrders extends Layout {
    chartOrders: Chart;
    sourceBPPerfOrders: DataSource;
    tableBPPerfOrders: Table;
}
